module.exports = {
  'userQuotas': '/api/bm/getUserQuotas',
};



// WEBPACK FOOTER //
// ./src/api/basicInstance/list/config.js